import { Stack, Typography } from "@mui/material";

import { EXPERIMENT_MISSION_PROCESSING_STATUS } from "../../constants";
import { TrafficTable } from "./";

export const ProcessingTraffic = () => {
    const statusFilterString = `processingStatus[0]=${EXPERIMENT_MISSION_PROCESSING_STATUS.NOT_STARTED}&processingStatus[1]=${EXPERIMENT_MISSION_PROCESSING_STATUS.ONGOING}&processingStatus[2]=${EXPERIMENT_MISSION_PROCESSING_STATUS.ERROR}`;
    return (
        <Stack spacing={2}>
            <Typography variant="h4">Processing Traffic</Typography>
            <TrafficTable statusFilterString={statusFilterString} />
        </Stack>
    );
};
